import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ThemeContext from '../../theme/ThemeContext';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 6px;
  border-radius: 99px; // just a high number to create pill effect
  background-color: ${(props) => props.theme.secondaryColor};

  * {
    z-index: 2;
  }

`;

const StyledTabs = styled.div`
  display: flex;
  position: relative;
`;

const StyledTabLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 99px; // just a high number to create pill effect
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  color: ${(props) => props.theme.fontColorSecondary};

  &.active, &:hover {
    cursor: pointer;
    svg {
      color: ${(props) => props.theme.fontColorPrimary};
    }
  }


`;

const StyledGlider = styled.span`
  position: absolute;
  display: flex;
  width: 200px;
  background-color: grey;
  z-index: 1;
  border-radius: 99px; // just a high number to create pill effect
  transition: 0.15s ease-out;
  background-color: ${(props) => props.theme.backgroundColor};

  ${(props) => {

    let styles = '';

    props.tabs.forEach((tab, i) => {
      styles += `
        &.active-${i} {
          transform: translateX(${props.tabWidth * i}px);
        }
      `;
    });

    return styles;

  }}
`;

const StyledIcon = styled.span`
  padding-right: 4px;
  svg {
    transition: all 0.15s ease-in-out;
  }
`;

const TabSlider = ({ onChange, tabs, tabWidth, tabHeight, tabStyles }) => {

  const theme = useContext(ThemeContext);
  const [active, setActive] = useState(0);

  const TabNodes = tabs.map(({ id, icon, iconSize }, i) => {

    const iconNode = !icon ? null : (
      <StyledIcon theme={theme}>
        <FontAwesomeIcon icon={icon} size={iconSize} />
      </StyledIcon>
    );

    return (
      <StyledTabLabel
        theme={theme}
        key={i}
        className={active === i ? 'active' : ''}
        style={{
          width: tabWidth,
          height: tabHeight,
          ...tabStyles,
        }}
        onClick={() => {
          setActive(i);
          if (onChange) onChange(id);
        }}
      >
        {iconNode}
      </StyledTabLabel>
    );
  });

  return (
    <StyledWrapper theme={theme}>
      <StyledTabs>
        {TabNodes}
        <StyledGlider
          theme={theme}
          className={`glider active-${active}`}
          style={{
            width: tabWidth,
            height: tabHeight,
          }}
          tabs={tabs}
          tabWidth={tabWidth}
        />
      </StyledTabs>
    </StyledWrapper>
  );
};

export default React.memo(TabSlider);
